// 고객 화면 하단 「buildpy로 관리되는 현장입니다」 한 줄 — 설정 `brand.footer` 가 "false" 일 때만 끈다(기본 켬).

export const BRAND_FOOTER_TEXT = "buildpy로 관리되는 현장입니다";
// 화면은 이름 자리에 로고를 그리고 뒤에 이 말만 붙인다 — 읽기 프로그램은 BRAND_FOOTER_TEXT 를 읽는다.
export const BRAND_FOOTER_SUFFIX = "로 관리되는 현장입니다";
export const BRAND_FOOTER_HREF = "/?from=customer";

export const isBrandFooterOn = (raw: string | null | undefined): boolean => raw !== "false";
